 ko.bindingHandlers["focusOnTab"] =
     "init": (element, valueAccessor) ->
         idToFocus = ko.unwrap(valueAccessor())
         return unless idToFocus
         $(element).keydown (e) ->
             keyCode = if e.which then e.which else e.keyCode
             if keyCode == 9
                 e.preventDefault();
                 e.stopPropagation();
                 $("##{idToFocus}").focus()